var validation = {

	validate: function (form, scrollToFirstErrorField, dropzones) {
		this.form = form
		this.errors = []

		// get all input fields
		var inputs = form.querySelectorAll('input:not([type=\'submit\']):not(.invisible-empty-radio):not(.invisible-empty-checkbox), textarea, select')

		for (var i = 0, l = inputs.length; i < l; i++) {
			var required = inputs[i].getAttribute('required')

			// when a field's parent has a conditional-hidden class we also do not validate it even when it is required
			var conditionalContainer = inputs[i].closest('[data-conditional]')
			if (conditionalContainer && conditionalContainer.classList.contains('conditional-hidden')) continue

			// don't validate fields that are not required unless they have input
			if (inputs[i].type !== 'checkbox' && inputs[i].type !== 'radio' && inputs[i].tagName !== 'SELECT') {
				if (required === null && inputs[i].value === '') {
					continue
				}
			} else {
				if (required === null) {
					continue
				}
			}

			// check inputs with a defined regex pattern
			var pattern = inputs[i].getAttribute('pattern')
			if (pattern) {
				var patternValid = this._testPattern(inputs[i], pattern)
				this._toggleError(patternValid, inputs[i])
			} else {
				// no pattern defined
				var valid = false
				if (inputs[i].value !== '' && inputs[i].type !== 'checkbox' && inputs[i].type !== 'radio') {
					valid = true
					this._toggleError(valid, inputs[i])
				} else if (inputs[i].type === 'checkbox') {
					valid = this.checkOtherCheckboxesWithSameName(inputs[i])
					this._toggleError(valid[0], inputs[i])
				} else if (inputs[i].type === 'radio') {
					valid = this.checkOtherRadioWithSameName(inputs[i])
					this._toggleError(valid[0], inputs[i])
				} else {
					this._toggleError(valid, inputs[i])
				}
			}
		}

		// only validate if there are dropzones passed as a parameter
		if (dropzones) {
			if (dropzones.length > 0) this.validateDropzones(dropzones)
		}

		// if our error is inside a collapsed editable reference we have to open
		for (var e = 0; e < this.errors.length; e++) {
			var collapsedEditableReference = this.errors[e].closest('.item.draggable-item')
			if (collapsedEditableReference) {
				collapsedEditableReference.classList.add('collapsed')
			}
		}

		var firstErr = this.errors[0]
		if (scrollToFirstErrorField && this.errors.length >= 1) this.scrollToError(firstErr)

		return this.errors.length < 1
	},

	validateDropzones: function (dropzones) {
		// validate the dropzones as well
		// only validate the dropzones for the active languages
		// get active languages
		var langToggles = document.querySelectorAll('[data-toggle-lang].active')
		var activeLangs = []
		for (var l = langToggles.length - 1; l >= 0; l--) {
			var locale = langToggles[l].getAttribute('data-toggle-lang')
			activeLangs.push(locale)
		}

		for (var i = dropzones.length - 1; i >= 0; i--) {
			var conditionalContainer = dropzones[i].hiddenValueField.closest('[data-conditional]')
			if (conditionalContainer && conditionalContainer.classList.contains('conditional-hidden')) continue

			// check if dropzone locale is an active language
			// if the dropzone has no locale that means it is synced and should always be validated
			var index = activeLangs.indexOf(dropzones[i].locale)
			if (index > -1 || dropzones[i].locale === null) {
				if (dropzones[i].required && dropzones[i].valuesArr.length === 0) {
					// set error on this dropzone
					dropzones[i].setError()
				} else {
					dropzones[i].removeError()
				}
			}
		}
	},

	checkOtherRadioWithSameName: function (input, form) {
		if (form) {
			this.form = form
		}

		var checked = false
		var checkedVal = 0
		var name = input.getAttribute('name')
		var allRadioWithName = this.form.querySelectorAll('input[type="radio"][name="' + name + '"]:not(.invisible-empty-radio)')

		for (var i = allRadioWithName.length - 1; i >= 0; i--) {
			if (allRadioWithName[i].checked) {
				checked = true
			}
			checkedVal = allRadioWithName[i].value

			if (i === 0) {
				// return true or false and the value of the checked radio
				return [checked, checkedVal]
			}
		}
	},

	checkOtherCheckboxesWithSameName: function (input, form) {
		if (form) {
			this.form = form
		}

		var checked = false
		var checkedVal = 0
		var name = input.getAttribute('name')
		var allCheckboxesWithName = this.form.querySelectorAll('input[type="checkbox"][name="' + name + '"]:not(.invisible-empty-checkbox)')

		for (var i = allCheckboxesWithName.length - 1; i >= 0; i--) {
			if (allCheckboxesWithName[i].checked) {
				checked = true
			}
			checkedVal = allCheckboxesWithName[i].value

			if (i === 0) {
				// return true or false and the value of the checked checkbox
				return [checked, checkedVal]
			}
		}
	},

	_toggleError: function (valid, input) {
		var listElement = input.closest('div.lang')
		if (!listElement) listElement = input.closest('div.sync')
		if (!listElement) listElement = input.closest('li')

		if (input.getAttribute('type') === 'hidden') return
		if (listElement.classList.contains('hidden') || listElement.classList.contains('disabled')) {
			return
		}

		if (!valid) {
			listElement.classList.add('error')
			this.errors.push(input)
		} else {
			listElement.classList.remove('error')
		}
	},

	_testPattern: function (input, pattern) {
		var pattern2 = new RegExp(pattern)
		return pattern2.test(input.value)
	},

	scrollToError: function (el) {
		// check if the element is visible
		var style = getComputedStyle(el, null).display
		if (style === 'none') {
			el = el.parentNode
		}
		el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
	}
}

export default validation
